import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';

export interface popoutMessage {
    origin: string;
    data: unknown;
}

@Injectable({ providedIn: 'root' })
export class popoutService {
    private popoutRef: Window | null = null;
    private generalMessage$ = new Subject<popoutMessage>();
    private dashboardMessage$ = new Subject<popoutMessage>();
    private readonly name = 'childPopup';
    private readonly features = 'width=800,height=640,menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes';
    private subscriptionListeners = new Set<string>();

    
    constructor(private zone: NgZone) {
        window.addEventListener('message', (event: MessageEvent) => {
            // Re-enter Angular zone so subscribers update UI
            this.zone.run(() => {
                if (this.isListening('ZuggitCpDispatchNeedsPartsGridComponent')) {
                    this.dashboardMessage$.next({ origin: event.origin, data: event.data });
                }
                else {
                    this.generalMessage$.next({ origin: event.origin, data: event.data });
                }
            });
        });
    }

    open(url: string, name = 'child', features = 'width=700,height=600,menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes') {
        this.popoutRef = window.open(url, name, features);
        return this.popoutRef;
    }

    openOrReuse(url: string) {
        // This will REUSE an existing window with the same name (or open if not present)
        this.popoutRef = window.open(url, this.name, this.features);
        this.popoutRef?.focus();
    }

    send(message: unknown, targetOrigin: string = '*') {
        this.popoutRef?.postMessage(message, targetOrigin);
    }

    close() {
        this.popoutRef?.close();
        this.popoutRef = null;
    }

    generalMessages$() {
        return this.generalMessage$.asObservable();
    }
    dashBoardMessages$() {
        return this.dashboardMessage$.asObservable();
    }
    isOpen() {
        return !!this.popoutRef && !this.popoutRef.closed;
    }

    register(name: string) {
        this.subscriptionListeners.add(name);
    }

    unregister(name: string) {
        this.subscriptionListeners.delete(name);
    }

    isListening(name: string) {
        return this.subscriptionListeners.has(name);
    }
}